import React from "react";
import { MapPin } from "lucide-react";
import { CITIES } from "../mock";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="home-section" style={{ scrollMarginTop: 120, background: "linear-gradient(180deg, #fff 0%, var(--cream) 100%)" }}>
      <div className="container grid items-start gap-10 lg:grid-cols-[1fr_0.9fr]">
        <div className="reveal">
          <p className="eyebrow">About Kapatia</p>
          <h2 className="mt-3 font-heading font-extrabold leading-[1.06]"
              style={{ color: "var(--green-950)", fontSize: "clamp(28px,3.6vw,42px)" }}>
            Professional dealing for corporate IT &amp; office assets
          </h2>
          <p className="mt-4 text-[17px]" style={{ color: "var(--muted)" }}>
            Kapatia Pvt Ltd works with businesses that need fast, clear and practical support for
            IT procurement, pre-owned product sourcing and surplus equipment sale. The focus is
            B2B coordination, bulk handling and useful recovery value.
          </p>
        </div>

        <div className="reveal rounded-2xl border p-6" style={{ background: "var(--cream)", borderColor: "var(--line)", boxShadow: "var(--shadow)" }}>
          <strong className="font-heading text-[21px] font-extrabold" style={{ color: "var(--green-950)" }}>Service Cities</strong>
          <div className="mt-4 grid grid-cols-2 gap-3">
            {CITIES.map((c) => (
              <span key={c} className="flex min-h-[54px] items-center justify-center gap-2 rounded-xl border font-heading font-bold"
                    style={{ background: "var(--cream)", borderColor: "var(--line)", color: "var(--green-950)" }}>
                <MapPin size={17} style={{ color: "#E8501A" }} /> {c}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
